import { useAuth } from '@modules/auth/use-auth.hook'
import { Roles } from '@shared/types'

export function useIsClientBasic() {
  const { authenticatedUser, authStatus } = useAuth()

  if (authStatus === 'unknown') {
    return false
  }

  return Boolean(
    authenticatedUser?.userRoles
      .map(({ roleName }) => roleName)
      .every((userRoleName) => userRoleName === Roles.ClientBasic)
  )
}
